import React from 'react';

const customerClasses = [
  'cgd',
  'montepio',
  'media_capital',
  'auchan',
  'cegid',
  'eurobic',
  'itau',
  'trablisa',
  'siva',
  'vodafone',
  'saphety',
];

const CustomersSection = () => (
  <section className="customers">
    <h3>Our customers</h3>
    <div className="logos">
      {['Caixa Geral de Depósitos', 'Montepio', 'Media Capital', 'Auchan', 'Cegid', 'Eurobic', 'Itau', 'Trablisa', 'Siva', 'Vodafone', 'Saphety'].map(
        (customer, index) => (
          <img
            key={index}
            src={`customers/${customerClasses[index]}.png`}
            alt={customer}
            className={customerClasses[index]}
          />
        )
      )}
    </div>
  </section>
);

export default CustomersSection;
